// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion--3MxdQ","accordionTitle":"accordionTitle--2dBVp"};